export const boundaryListActionType = 'BOUNDARY_LIST'